import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import sessionManager from '../utils/sessionManager';

/**
 * Component that monitors route changes and updates session activity
 * This ensures that navigation between pages extends the session
 */
const SessionActivityTracker = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    // Update session activity whenever user navigates to a new route
    sessionManager.updateActivity();
    console.log('🔄 Route change detected, session activity updated:', location.pathname);
  }, [location.pathname]);

  return children;
};

export default SessionActivityTracker;
